module.exports = __webpack_public_path__ + "static/media/screenshot.f920fff3.png";